export const environment = {
  production: true,
  auth0: {
    domain: `senseye.eu.auth0.com`,
    clientId: `4AUSQLEiN7oXzJJaMmrjsyCudQFFl7wE`,
    audience: `https://api.senseye.io`,
    scope: `openid email profile`,
    claimsNamespacePrefix: `https://api.senseye.io`,
  },
  api: {
    baseUrl: `https://api.senseye.io`,
  },
};
